var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-MapKey" }, [
    _c(
      "div",
      { staticClass: "key-col" },
      _vm._l(_vm.getMapKeyLabels().slice(0, 3), function(item, idx) {
        return _c("div", { key: "col-1-" + idx }, [
          _c("span", { staticClass: "c-MapKey__keyColWrap" }, [
            _c("span", { class: "key-color key-color--" + item.color })
          ]),
          _vm._v(" "),
          _c("span", { class: "label" }, [
            _vm._v("\n                " + _vm._s(item.label) + "\n            ")
          ])
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "key-col" },
      _vm._l(_vm.getMapKeyLabels().slice(3, 6), function(item, idx2) {
        return _c("div", { key: "col-2-" + idx2 }, [
          _c("span", { staticClass: "c-MapKey__keyColWrap" }, [
            _c("span", { class: "key-color key-color--" + item.color })
          ]),
          _vm._v(" "),
          _c("span", { class: "label" }, [
            _vm._v("\n            " + _vm._s(item.label) + "\n            ")
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }